class WishlistManage extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleExternalTrigger = this.handleExternalTrigger.bind(this)
    this.handleInput = this.handleInput.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleSuccess = this.handleSuccess.bind(this)
    this.wishlistError = this.wishlistError.bind(this)

    this.listeners.add(document, 'click', this.handleExternalTrigger)
    this.listeners.add(this.els.input.element, 'input', this.handleInput)
    this.listeners.add(this.els.submit.element, 'click', this.handleSubmit)
  }

  handleExternalTrigger (event) {
    const trigger = event.target.closest(
      '[data-wishlist-manage-external-el="trigger"]',
    )

    if (!trigger) return

    this.els.input.element.value = ''

    this.els.input.element.placeholder =
      this.translations?.wishlist?.manage?.createPlaceholder

    this.els.title.element.textContent =
      this.translations?.wishlist?.manage?.createTitle

    this.els['submit-text'].element.textContent =
      this.translations?.wishlist?.manage?.createSubmit

    this.validateForm()

    window.drawers.activeDrawerKey = 'drawer-wishlist-manage'
  }

  handleInput () {
    this.validateForm()
  }

  validateForm () {
    const name = this.els.input.element.value.trim()

    this.els.submit.element.disabled = this.els.submit.element.disabled =
      name === ''
  }

  handleSubmit () {
    const name = this.els.input.element.value.trim()

    if (!name || !window._swat) return

    this.els.submit.element.disabled = true

    this.createWishlist(name)
  }

  createWishlist (name) {
    window._swat.createList(
      { lname: name },
      this.handleSuccess,
      this.wishlistError,
    )
  }

  handleSuccess () {
    window.drawers.activeDrawerKey = ''

    window.BAO.dispatchEvent(window.BAO.EVENTS.WISHLIST.LISTS_CHANGED)
  }

  wishlistError (errorMessage) {
    this.els.submit.element.disabled = false

    // eslint-disable-next-line
    console.error("Wishlist error", errorMessage);
  }

  get translations () {
    return window.theme ?? {}
  }
}

if (!customElements.get('wishlist-manage')) {
  customElements.define('wishlist-manage', WishlistManage)
}
